<template>
  <div>
    <div class="modal fade show" style="display: block;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Przypisz kartę do klienta</h4>
            <button class="close" type="button" @click="cancelUpdate()" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="assignClient()">
              <div class="row">
                <div class="form-group col-md-4">
                  <label for="clientId">Id klienta</label>
                  <input class="form-control" id="clientId" autocomplete="off" v-model="clientId"
                         type="text"/>
                </div>
              </div>
              <button class="btn btn-primary mr-2" type="submit">Zmień</button>
              <button class="btn btn-secondary" @click="cancelUpdate()" type="button">Anuluj</button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
  import loyaltyCardsService from '@Service/loyaltyCards';
  import { toastError } from '../helpers';

  export default {
    props: ['loyaltyId'],
    data() {
      return {
        clientId: '',
      };
    },
    methods: {
      cancelUpdate() {
        this.$emit('assign-cancel');
      },
      assignClient() {
        loyaltyCardsService.assignClient(this.loyaltyId, this.clientId)
          .then(() => {
            this.$emit('assign-success');
            this.cancelUpdate();
          })
          .catch(toastError);
      },
    },
  };
</script>
